import React from "react";
export const TopTimeLine = ({ date, comment }) => (React.createElement("div", { className: "top-time-line" },
    React.createElement("span", null, date),
    React.createElement("p", null, comment)));
